import { useState, useEffect } from "react";
import { useStore } from "@/store";
import { supabase } from "@/integrations/supabase/client";

type SubscriptionAnimationState = "none" | "upgrading" | "downgrading" | "expired";

export const useSubscriptionAnimation = () => {
  const { profile } = useStore();
  const [animationState, setAnimationState] = useState<SubscriptionAnimationState>("none");
  const [prevIsPro, setPrevIsPro] = useState<boolean | null>(null);

  useEffect(() => {
    if (profile && prevIsPro !== null) {
      // User just upgraded
      if (!prevIsPro && profile.is_pro) {
        setAnimationState("upgrading");
      }
      // User just downgraded or expired
      else if (prevIsPro && !profile.is_pro) {
        // Check if it's an expiration or manual downgrade
        const checkExpiration = async () => {
          const { data } = await supabase
            .from("subscriptions")
            .select("expires_at, status")
            .eq("user_id", profile.id)
            .eq("status", "expired")
            .order("created_at", { ascending: false })
            .limit(1)
            .maybeSingle();

          if (data) {
            setAnimationState("expired");
          } else {
            setAnimationState("downgrading");
          }
        };

        checkExpiration();
      }
    }

    if (profile) {
      setPrevIsPro(profile.is_pro);
    }
  }, [profile?.is_pro]);

  const completeAnimation = () => {
    setAnimationState("none");
  };

  return {
    animationState,
    completeAnimation,
  };
};
